import CoreSocialMediaEmbeds from './CoreSocialMediaEmbeds';

export { type CoreSocialMediaEmbedsProps } from './CoreSocialMediaEmbeds';
export default CoreSocialMediaEmbeds;
